<article class="content">
  <h1>Terms of Service</h1>
  <p>Last updated: July 3, 2025</p>

  <p>
    Welcome to Pink Soul. These Terms of Service ("Terms") govern your use of
    our website <strong>https://pinksoul.us</strong> ("Site"). By accessing or
    using our Site, you agree to comply with and be bound by these Terms.
  </p>

  <h2>1. Eligibility</h2>
  <p>
    You must be at least 18 years old or have legal guardian consent to use this
    Site. By creating an account or making a purchase, you confirm that you meet
    this requirement.
  </p>

  <h2>2. Account Responsibility</h2>
  <p>
    You are responsible for maintaining the confidentiality of your account
    login information and for all activities that occur under your account.
  </p>

  <h2>3. Product Information</h2>
  <ul>
    <li>
      All products are subject to availability. We reserve the right to limit
      quantities.
    </li>
    <li>
      We strive to display accurate product descriptions and images but do not
      guarantee that all details are error-free.
    </li>
    <li>Prices are listed in USD and may change without notice.</li>
  </ul>

  <h2>4. Orders and Payment</h2>
  <p>
    Orders are processed securely through Stripe. By placing an order, you
    authorize us to charge the payment method you provide. We may cancel or
    refuse any order at our sole discretion.
  </p>

  <h2>5. Shipping</h2>
  <p>
    Shipping times and fees are displayed at checkout. Orders are shipped to the
    address provided. We are not responsible for delays caused by carriers or
    customs.
  </p>

  <h2>6. Return & Refund Policy</h2>
  <p>
    If you are not satisfied with your purchase, you may request a return within
    <strong>14 days</strong> of delivery. Items must be unused, in original
    condition, and with all tags attached.
  </p>
  <ul>
    <li>
      To start a return, contact us at
      <a href="mailto:support@pinksoul.us">support&#64;pinksoul.us</a>.
    </li>
    <li>
      Customers are responsible for return shipping unless the item is defective
      or incorrect.
    </li>
    <li>
      Refunds are issued to the original payment method within 5–10 business
      days after we receive the returned item.
    </li>
    <li>Final sale items are not eligible for return or refund.</li>
  </ul>

  <h2>7. Cookies and Tracking Technologies</h2>
  <p>
    We use cookies and similar technologies to enhance your experience, analyze
    site traffic, and deliver personalized content. By using the Site, you
    consent to our use of cookies.
  </p>
  <ul>
    <li>
      <strong>Essential cookies:</strong> Required for basic site functions like
      login and cart management.
    </li>
    <li>
      <strong>Analytics cookies:</strong> Help us understand user behavior to
      improve our services.
    </li>
    <li>
      You can control cookies through your browser settings. Disabling cookies
      may affect functionality.
    </li>
  </ul>

  <h2>8. Intellectual Property</h2>
  <p>
    All content on the Site, including text, graphics, logos, images, and
    software, is the property of Pink Soul and is protected by copyright and
    trademark laws. You may not copy, use, or distribute any content without our
    written permission.
  </p>

  <h2>9. Limitation of Liability</h2>
  <p>
    To the maximum extent permitted by law, Pink Soul is not liable for any
    indirect, incidental, or consequential damages arising from your use of the
    Site or purchase of our products.
  </p>

  <h2>10. Termination</h2>
  <p>
    We reserve the right to suspend or terminate your access to the Site at our
    sole discretion, without notice, for any conduct that violates these Terms.
  </p>

  <h2>11. Changes to Terms</h2>
  <p>
    We may update these Terms from time to time. Changes will be posted on this
    page with an updated "Last Updated" date. Continued use of the Site
    constitutes acceptance of the revised Terms.
  </p>

  <h2>12. Governing Law</h2>
  <p>
    These Terms are governed by the laws of the State of California, USA,
    without regard to its conflict of law principles.
  </p>

  <h2>13. Contact Us</h2>
  <p>
    If you have any questions about these Terms, please contact us at
    <a href="mailto:support@pinksoul.us">support&#64;pinksoul.us</a>.
  </p>
</article>
